import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { setDefaultOptions } from 'date-fns';
import { WeekDay } from '@core/models/week-day';

setDefaultOptions({ weekStartsOn: WeekDay.Monday });

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
